export function isImageSvg(filename) {
    return filename.endsWith('.svg') || false; // Might better to use `type` of directus file
}
